import { Controller } from "@hotwired/stimulus"

// Auto-soumet un formulaire de filtre sans recharger la page : le formulaire porte
// `data-turbo-stream`, donc `requestSubmit()` déclenche une requête Turbo Stream qui re-rend
// la liste seule.
//
// LA SAISIE EST DEBOUNCÉE, LES FILTRES SOUMETTENT IMMÉDIATEMENT. Cocher une pastille est un
// geste arrêté, il n'y a rien à attendre ; taper une recherche, non — envoyer à chaque frappe
// ferait une requête par lettre pour un résultat que personne n'a fini de demander.
//
// Le contrôleur est posé sur un conteneur qui englobe la barre ET la liste : `this.element`
// n'est donc pas le formulaire, d'où la cible `form`.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }
  static targets = ["form", "query"]

  connect() {
    this.timeout = null
    this.placeCaretAtEnd()
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  // Champ de recherche pré-rempli : le focus du navigateur place le curseur au DÉBUT du
  // texte, si bien qu'affiner sa recherche insère les lettres devant le terme — on tape « r »
  // après « danse » et on obtient « rdanse ». On prend donc le focus et on pose le curseur à
  // la fin.
  //
  // Sans champ vide, rien ne se produit : ouvrir la liste ne vole pas le focus.
  placeCaretAtEnd() {
    if (!this.hasQueryTarget) return

    const field = this.queryTarget
    if (!field.value) return

    field.focus()
    field.setSelectionRange(field.value.length, field.value.length)
  }

  // Frappe dans le champ de recherche : on attend une pause avant de soumettre.
  debouncedSubmit() {
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), this.delayValue)
  }

  // Changement de filtre, ou fin d'attente après la frappe.
  submit() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
    this.formTarget.requestSubmit()
  }
}
